import { render, staticRenderFns } from "./ChannelPublication.vue?vue&type=template&id=a7b53d44&"
import script from "./ChannelPublication.vue?vue&type=script&lang=js&"
export * from "./ChannelPublication.vue?vue&type=script&lang=js&"
import style0 from "./ChannelPublication.vue?vue&type=style&index=0&id=a7b53d44&prod&lang=scss&"
import style1 from "./ChannelPublication.vue?vue&type=style&index=1&id=a7b53d44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports